import { render } from "./UploadPackingList.vue?vue&type=template&id=443c3372"
import script from "./UploadPackingList.vue?vue&type=script&lang=js"
export * from "./UploadPackingList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/agro_exporter/production/uniq_final_packing_list/upload_packing_list.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fproduction%2Funiq_final_packing_list%2FUploadPackingList.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__